import { connect } from "react-redux";
import { showInMaVachTaiSan } from "actions/InMaVachTaiSan";
import InMaVachTaiSan from "components/CommonComponent/InMaVachTaiSan";

const mapStateToProps = (state) => ({
  inmavachtaisan: state.inmavachtaisan,
  camdo: state.camdo,
});

const mapDispatchToProps = (dispatch) => ({
  showInMaVachTaiSan: () => dispatch(showInMaVachTaiSan()),
});

export default connect(mapStateToProps, mapDispatchToProps)(InMaVachTaiSan);
